module.exports = __webpack_public_path__ + "img/111.91c1bdf6.png";